// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"DataConnectorAlerts-primaryButton-2vm7BM","textGlobalAlerts":"DataConnectorAlerts-textGlobalAlerts-3VR8BH"};